
import i18n from 'i18next';
import { API } from "services/api";

import { Languages as LanguagesFallback } from "config/LanguageList.jsx";

function checkTrans(ns) {

  if (!i18n.hasResourceBundle('hr', ns)) { //if resource is missing for current languages
    API.getLanguages() //we will retrieve all the languages from db (because i18n.languages might miss some)
    .then(langs => {
        if (!langs) {
            console.warn('Loading Fallback languages!');
            langs = LanguagesFallback;
        }
        langs.forEach(function(lang){ // and then we retrieve translations for all the languages
          if (!i18n.hasResourceBundle(lang.code, ns)) {
            API.getTranslations(lang.code, ns)
            .then(data => {
                if (data) {
                    i18n.addResourceBundle(lang.code, ns, data);
                } else {
                    console.error('Cannot load translations for language: ' + lang.code + ", group: " + ns);
                }
            });
          }
        });
    });
  }
}

export { checkTrans }